import React, { useState, useRef, useEffect } from "react";

const Dropdown = ({
  trigger,
  children,
  isOpen,
  onToggle,
  className = "",
  dropdownClassName = "",
  placement = "bottom-end", // bottom-start, bottom-end, top-start, top-end
}) => {
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target)
      ) {
        onToggle(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onToggle]);

  const getPlacementClasses = () => {
    switch (placement) {
      case "bottom-start":
        return "top-full left-0 mt-2";
      case "bottom-end":
        return "top-full right-0 mt-2";
      case "top-start":
        return "bottom-full left-0 mb-2";
      case "top-end":
        return "bottom-full right-0 mb-2";
      default:
        return "top-full right-0 mt-2";
    }
  };

  return (
    <div className={`relative inline-block ${className}`}>
      <div ref={triggerRef} onClick={() => onToggle(!isOpen)}>
        {trigger}
      </div>
      
      {isOpen && (
        <div
          ref={dropdownRef}
          className={`absolute z-50 bg-white rounded-lg border border-gray-300 shadow-xl ${getPlacementClasses()} ${dropdownClassName}`}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default Dropdown; 